export async function fetchWallet(accessToken) {
  const response = await fetch(
    `${process.env.GATSBY_BLOCKCHAIN_API_URL}/user/wallet`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )
  const data = await response.json()
  const wallets = data.result
  return wallets
}
